import React, { useEffect, useMemo, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import List from '../../components/List'
import FloatingButton from '../../components/UI/FloatingButton'
import SmartSearch from '../../components/UI/SmartSearch'
import SwitchInput from '../../components/UI/SwitchInput'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getBingoGamesList, updateBingoGames } from '../../services/bingoGames'
import { numberToCurrency } from '../../utils/objectUtils'
import { IBingoGame, IBingoForm } from './types'
import { serverUrl } from '../../services/api'



function index(props: { accessLevel: string }) {

  const { canEdit } = useAuth()
  const loading = useLoading()
  const log = {
    log_type: 'visited',
    log_object: 'bingo_games'
  }
  const [search, setSearch] = useState({
    text: '',
    id: '',
  })
  

  const [games, setGames] = useState<IBingoGame[]>([{
    gameImage: "",
    gameTitle: "",
    forms: [
      {
        form: "",
        wager: "",
        available: "No"
      }
    ]
  }])

  const [gamesInitial, setGamesInitial] = useState<IBingoGame[]>([{
    gameImage: "",
    gameTitle: "",
    forms: [
      {
        form: "",
        wager: "",
        available: "No"
      }
    ]
  }])

  const [validSearch, setValidSearch] = useState(false)

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  useEffect(() => {
    sendSystemLog(log);
  }, []);

  const onRefresh = async () => {
    loading.addLoading()
    const gamesRequest = await getBingoGamesList({ id: search.id })
    setGames(gamesRequest.list as any)
    const gamesToStore = await getBingoGamesList({ id: search.id })
    setGamesInitial(gamesToStore.list as any)
    loading.removeLoading()
  }

  const onCheckChange = (value: 'Yes' | 'No', gameIndex: number, formIndex: number) => {
    let formToChange = games
    formToChange[gameIndex].forms[formIndex].available = value
    setGames([...formToChange])
  }


  const onSubmit = async () => {
    loading.addLoading()
    let payload: any[] = []
    games.forEach(game => {
      return game.forms.forEach((form) => payload.push(form))
    })
    await updateBingoGames(payload, search.id)
    loading.removeLoading()
    onRefresh()
  }

  const getImageLink = (img: string) => {
    return img.replace('images/','') || '';
  }

  return (
    <div className="bingo-games">
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <FloatingButton text="Save Changes" onClick={onSubmit} disabled={(JSON.stringify(games) === JSON.stringify(gamesInitial)|| !canEdit)}/>
      <ActionArea buttonText={'Search'} buttonAction={onRefresh} disabled={!validSearch}>
        <SmartSearch
          label="Smart Search"
          searchBy={['location']}
          value={search.text}
          status="active"
          onChange={(e) => setSearch({ ...search, text: e })}
          onValidSearch={setValidSearch}
          onObjValueChange={e => setSearch({ ...search, id: e.id })}
          autoFocus
        />
      </ActionArea>
      <div className="bingo-games"> 
        {games && games[0].gameImage && games.map((game, index) => (
          <div className="bingo-games__table">
            <div className="bingo-games__table__header">
              <img src={serverUrl + game.gameImage} alt="" />
              <h2>
                {game.gameTitle}
              </h2>
            </div>
            <div className="bingo-games__table__list">
              <List
                style={{maxWidth: '100%'}}
                pagination={false}
                columns={[
                  {
                    title: 'Form',
                    dataIndex: 'form',
                    key: 'form',
                    render: (value: string) => value,
                    width: 150
                  },
                  {
                    title: 'Wager',
                    dataIndex: 'wager',
                    key: 'wager',
                    render: (value: string) => `${numberToCurrency(value)}`,
                    width: 150
                  },
                  {
                    title: 'Available',
                    dataIndex: 'available',
                    key: 'available',
                    render: (value: 'Yes' | 'No', record: IBingoForm, formIndex: number) => (
                      <SwitchInput 
                        onChange={(e) => onCheckChange(e, index, formIndex)} 
                        options={{check: 'Yes', uncheck: 'No'}} 
                        value={value}
                        disabled={(!canEdit)}
                      />
                    ),
                    width: 150
                  },
                ]}
                rows={game.forms}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default index